import React, { useEffect, useState } from "react";
import Card from "../components/Cards/Card";
import Dashtabs from "../components/Tab/Dashtabs";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import SettingsPopover from "../components/popup/SettingsPopover";
import { useDispatch } from "react-redux";
import { clearOrderDraft } from "../redux/slices/orderDraftSlice";
import { clearSubsOrderDraft } from "../redux/slices/SubscriptionDraftSlice";
import SImpleCardShimmer from "../components/Preloader/SImpleCardShimmer";
import { getDashCount } from "../redux/thunks/dashboardThunk";

const Dashboard = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [tLunch, setTLunch] = useState(0);
  const [tDinner, setTDinner] = useState(0);
  const [tTotal, setTTotal] = useState(0);
  const [curCode, setCurCode] = useState("");
  const [mealTiming, setMealTiming] = useState("all");

  useEffect(() => {
    dispatch(getDashCount())
      .unwrap()
      .then((res) => {
        // console.log("The res of given count is :", res.data);
        const getLunch = res.data?.lunch_orders;
        setTLunch(getLunch);

        const getDinner = res.data?.dinner_orders;
        setTDinner(getDinner);

        const getCurrency = res.data?.currency;
        setCurCode(getCurrency);

        const getTotal = res.data?.today_total_amount;
        setTTotal(getTotal);
  

        localStorage.setItem("currency", getCurrency);
      });
  }, [dispatch]);

  const cardsData = [
    { id: 1, cardTitle: "Today's Lunch Orders", cardOrder: tLunch },
    { id: 2, cardTitle: "Today's Dinner Orders", cardOrder: tDinner },
    {
      id: 3,
      cardTitle: "Today's Revenue",
      cardOrder: `${curCode}${Number(tTotal).toFixed(2)}`,
    },
  ];
  
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 300); // 1.5s shimmer
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    dispatch(clearOrderDraft());
    dispatch(clearSubsOrderDraft());
  }, [dispatch]);

  return (
    <section className="mt-4 md:mt-10 max-w-7xl mx-auto">
      <DecorativeSquares />
      <div className="md:bg-white md:rounded-md p-3 md:p-6 space-y-6  ">
        <div className="text-center md:text-start mb-4 space-y-2">
          <h1 className="text-[#191919] text-2xl md:text-3xl font-bold">
            Dashboard
          </h1>
          <p className=" text-sm text-[#747474]">Today's Booking Appear Here</p>
        </div>
        <div className="block md:hidden border-b mt-2 mb-2 text-gray-100 w-full shadow-xl"></div>

        {/* Cards */}

        <div className="grid grid-cols-3 gap-4">
          {loading
            ? Array.from({ length: 3 }).map((_, i) => (
                <SImpleCardShimmer key={i} />
              ))
            : cardsData.map((data, index) => (
                <Card
                  key={index}
                  title={data.cardTitle}
                  orders={data.cardOrder}
                />
              ))}
        </div>

        <div className="flex flex-row justify-between gap-4">
          <div>
            <h1>Today's Pending Orders</h1>
          </div>
          <div>
            <SettingsPopover mealTiming={mealTiming} onChange={setMealTiming} />
          </div>
        </div>
        <div>
          <Dashtabs mealTiming={mealTiming} />
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
